import React, { useState } from 'react';
import { useDashboardDomainContext } from '../../DashboardDomainProvider';
import { DialogControl, MultiSelectListControl } from 'spark-core-dx/components';
import moment from 'moment';

const OpenDashboardDialog = ({ isActive, closeDialog, scrollRef }) => {
  const { dashboardUserNavStateLib, dashboardLib } = useDashboardDomainContext();
  const [selectedValues, setSelectedValues] = useState([]);

  const listOfDashboards =
    (dashboardLib?.dashboardList ?? []).map((dashboard) => {
      const isPublished = !!dashboard?.State?.IsPublished;
      const name = isPublished
        ? dashboard?.PublishedDetails?.Name
        : (dashboard?.DraftDetails?.Name ??
           `Draft-${moment(dashboard?.UpdatedDate).format('MM/DD/YY')}`);
      const isTemplate = !!dashboard?.State?.IsTemplate;

      return {
        Text: name || 'Untitled',
        Value: dashboard?._id,
        className: isTemplate ? 'template' : '',
      };
    }).filter(item => !!item.Value); // ensure we have ids

  return (
    <DialogControl
      className="dashboard-dialog"
      openDialog={isActive}
      title="Open Dashboard"
      disableOk={selectedValues.length === 0}
      onOk={async () => {
        dashboardUserNavStateLib?.addMultipleDashboards?.(selectedValues);

        setTimeout(() => {
          if (scrollRef?.current) {
            const selectedTabElement = scrollRef.current.querySelector('.tab.selected');
            if (selectedTabElement) {
              const tabRect = selectedTabElement.getBoundingClientRect();
              const containerRect = scrollRef.current.getBoundingClientRect();

              if (tabRect.left < containerRect.left || tabRect.right > containerRect.right) {
                const scrollPosition =
                  selectedTabElement.offsetLeft -
                  (scrollRef.current.clientWidth / 2) +
                  (selectedTabElement.offsetWidth / 2);

                scrollRef.current.scrollTo({ left: scrollPosition, behavior: 'smooth' });
              }
            }
          }
          closeDialog();
          setSelectedValues([]);
        }, 50); // 50 is here
      }}
      onCancel={() => closeDialog()}
      okText="Open"
    >
      <div className="dialog-text">
        <div className="title">Select dashboard(s)</div>
        <MultiSelectListControl
          metadata={{ DataJson: listOfDashboards }}
          customDisabledText="No Dashboards Found..."
          value={selectedValues}
          onChange={(value) => setSelectedValues(value)}
        />
      </div>
    </DialogControl>
  );
};

export default OpenDashboardDialog;
